import {
    GET_APPROVAL_LIST_ASSIGNMENT,
    SET_APPROVAL_LIST_ASSIGNMENT,
    SAVE_APPROVAL_LIST_ASSIGNMENT,
    IS_APPROVAL_LIST_SAVED,
    GET_APPROVAL_LIST_EXCEL_DATA,
    SET_APPROVAL_LIST_EXCEL_DATA,
    GET_All_APPROVAL_LIST_EXCEL_DATA,
    SET_All_APPROVAL_LIST_EXCEL_DATA,
    VALIDATE_APPROVAL_LIST_ASSIGNMENT,
    IS_APPROVAL_LIST_VALIDATED,
    SET_ADDITIONAL_APPROVAL_LIST_ASSIGNMENT,
    GET_ADDITIONAL_APPROVAL_LIST_ASSIGNMENT
} from "./ApprovalListAssignmentType"

const getApprovalListAssignment = (payload: any) => ({
    type: GET_APPROVAL_LIST_ASSIGNMENT,
    payload
})

const setApprovalListAssignment = (response: any) => ({
    type: SET_APPROVAL_LIST_ASSIGNMENT,
    response
})

const getAdditionalApprovalListAssignment = (payload: any) => ({
    type: GET_ADDITIONAL_APPROVAL_LIST_ASSIGNMENT,
    payload
})

const setAdditionalApprovalListAssignment = (response: any) => ({
    type: SET_ADDITIONAL_APPROVAL_LIST_ASSIGNMENT,
    response
})

const saveApprovalListAssignment = (payload: any) => ({
    type: SAVE_APPROVAL_LIST_ASSIGNMENT,
    payload
})

const setIsApprovalListSaved = (response: any) => ({
    type: IS_APPROVAL_LIST_SAVED,
    response
})

const getApprovalListExcelData = (payload: any, isAdditionalApprover: boolean = false) => ({
    type: GET_APPROVAL_LIST_EXCEL_DATA,
    payload,
    isAdditionalApprover
})

const setApprovalListExcelData = (response: any) => ({
    type: SET_APPROVAL_LIST_EXCEL_DATA,
    response
})

const getAllApprovalListExcelData = (isAdditionalApprover: boolean = false) => ({
    type: GET_All_APPROVAL_LIST_EXCEL_DATA,
    isAdditionalApprover
})

const setAllApprovalListExcelData = (response: any) => ({
    type: SET_All_APPROVAL_LIST_EXCEL_DATA,
    response
})

const validateApprovalListAssignment = (payload: any) => ({
    type: VALIDATE_APPROVAL_LIST_ASSIGNMENT,
    payload
})

const setIsApprovalListValidated = (response: any) => ({
    type: IS_APPROVAL_LIST_VALIDATED,
    response
})


export {
    getApprovalListAssignment,
    setApprovalListAssignment,
    getAdditionalApprovalListAssignment,
    setAdditionalApprovalListAssignment,
    saveApprovalListAssignment,
    setIsApprovalListSaved,
    getApprovalListExcelData,
    setApprovalListExcelData,
    getAllApprovalListExcelData,
    setAllApprovalListExcelData,
    validateApprovalListAssignment,
    setIsApprovalListValidated
}